import moment from 'moment';

const defaultFilterState = {
    data: moment(),
    conta: '',
    status: '',
    tipo: '',
    orderBy: 'data_pagamento',
    filtroMensal: true,
    considerarPendentes: false,
};

export default function filtroReducer(state = defaultFilterState, action) {
    if( action.type === 'UPDATE_FILTER' ) {
        return Object.assign({}, state, action.filtro);
    }
    if( action.type === 'CLEAN_FILTER' ) {
        return defaultFilterState;
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/redux/reducers/filtroReducer.js